/**
 * Dynamic Size Selector Integration with Shopify Product Form
 * Integrates the custom size selector with Shopify's variant selection
 */

document.addEventListener('DOMContentLoaded', function() {
  // Listen for size selection events from our custom size selector
  document.addEventListener('sizeSelected', function(event) {
    const { size, country, sectionId } = event.detail;
    
    // Find the product form on the page
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;
    
    // Find all variant options in the form
    const variantOptions = productForm.querySelectorAll('input[name="id"]');
    
    // Try to match the selected size with a variant
    let matchingVariant = null;
    
    variantOptions.forEach(option => {
      const variantId = option.value;
      const variantElement = document.querySelector(`[data-variant-id="${variantId}"]`);
      
      if (variantElement) {
        const variantTitle = variantElement.getAttribute('data-variant-title') || '';
        const variantOptions = variantElement.getAttribute('data-variant-options');
        
        // Check if this variant matches the selected size
        if (variantTitle.toLowerCase().includes(size.toString().toLowerCase()) ||
            variantOptions?.toLowerCase().includes(size.toString().toLowerCase())) {
          matchingVariant = option;
        }
      }
    });
    
    // If we found a matching variant, select it
    if (matchingVariant) {
      matchingVariant.checked = true;
      matchingVariant.dispatchEvent(new Event('change', { bubbles: true }));
      
      // Update any variant picker UI
      updateVariantPicker(matchingVariant.value);
      
      console.log(`Selected variant ${matchingVariant.value} for size ${size} (${country})`);
    } else {
      console.log(`No variant found for size ${size} (${country})`);
    }
  });
  
  // Function to update variant picker UI
  function updateVariantPicker(variantId) {
    // Find and update variant picker buttons
    const variantButtons = document.querySelectorAll('[data-variant-id]');
    variantButtons.forEach(button => {
      if (button.getAttribute('data-variant-id') === variantId) {
        button.classList.add('selected');
        button.setAttribute('aria-pressed', 'true');
      } else {
        button.classList.remove('selected');
        button.setAttribute('aria-pressed', 'false');
      }
    });
    
    // Update variant selector dropdown if it exists
    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect) {
      variantSelect.value = variantId;
    }
  }
  
  // Sync size selector with Shopify variant changes
  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm) {
    productForm.addEventListener('change', function(event) {
      if (event.target.name === 'id') {
        const selectedVariantId = event.target.value;
        syncSizeSelectorWithVariant(selectedVariantId);
      }
    });
  }
  
  // Function to sync size selector with selected variant
  function syncSizeSelectorWithVariant(variantId) {
    const variantElement = document.querySelector(`[data-variant-id="${variantId}"]`);
    if (!variantElement) return;
    
    const variantTitle = variantElement.getAttribute('data-variant-title') || '';
    const variantOptions = variantElement.getAttribute('data-variant-options') || '';
    
    // Extract size information from variant
    const sizeMatch = variantTitle.match(/(\d+(?:\.\d+)?)/) || variantOptions.match(/(\d+(?:\.\d+)?)/);
    
    if (sizeMatch) {
      const size = sizeMatch[1];
      
      // Find all size selectors on the page
      const sizeSelectors = document.querySelectorAll('.dynamic-size-selector');
      
      sizeSelectors.forEach(selector => {
        const sizeButtons = selector.querySelectorAll('.size-selector__size-btn');
        
        sizeButtons.forEach(button => {
          if (button.textContent.trim() === size) {
            // Remove active class from all buttons in this selector
            sizeButtons.forEach(btn => btn.classList.remove('active'));
            // Add active class to matching button
            button.classList.add('active');
          }
        });
      });
      
      console.log(`Synced size selector with variant size: ${size}`);
    }
  }
  
  // Initialize size selector state based on current variant selection
  function initializeSizeSelector() {
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;
    
    const selectedVariant = productForm.querySelector('input[name="id"]:checked');
    if (selectedVariant) {
      syncSizeSelectorWithVariant(selectedVariant.value);
    }
  }
  
  // Initialize on page load
  initializeSizeSelector();
  
  // Re-initialize when product data changes (for AJAX-loaded products)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Check if product form was added
        const hasProductForm = Array.from(mutation.addedNodes).some(node => 
          node.nodeType === 1 && 
          (node.querySelector && node.querySelector('form[action*="/cart/add"]')) ||
          (node.matches && node.matches('form[action*="/cart/add"]'))
        );
        
        if (hasProductForm) {
          setTimeout(initializeSizeSelector, 100);
        }
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
